<template>
    <div v-if="$store.state.openid != ''">
        <top-bar>
            <div class="title">
                  个人信息
            </div>
        </top-bar>
        <ul class="userinfo" v-if="info">
            <li >
                <div>企业：</div>
                <span>{{ info. companyName}}</span>
            </li>
            <li >
                <div>姓名：</div>
                <span>{{ info. name}}</span>
            </li>
            <li >
                <div>身份证：</div>
                <span>{{ info. idcard}}</span>
            </li>
            <li >
                <div>手机号：</div>
                <span>{{ info. phone}}</span>
            </li>
            <li >
                <div>发薪次数：</div>
                <span>{{ info. payTimes}}</span>
            </li>
            <li >
                <div>累计收入：</div>
                <span>{{ info. amountIncome}}</span>
            </li>
            <li style="color:#00c3ff">
                <div>*备注：</div>
                <span>累计发薪次数及金额，从2020年10月份起计算</span>
            </li>
        </ul>
        <err msg="个人信息未查询到" v-else />
        <van-dialog v-model="show" title="提示" @confirm="confirm">
            <div class="cont">点击进行实名验证</div>
        </van-dialog>


    </div>
</template>

<script>
import TopBar from "@/components/Top";
import err from "./err";
import { selectSalary,getPerson,getOpenId,Loading } from "@/http/salary";
import { init,GetQueryString } from '@/utils/getOpenId'
import Vue from 'vue'
import { List } from 'vant';

Vue.use(List);

export default {
    components: {
        TopBar,
        err,
    },
    data() {
        return {
            salaryList: [],
            openid:'',
            show: false,
            info:{},
            loading: true,
        };
    },
    created() {
        this.$cookies.set('history','person',60 * 60 * 1)
        if(this.$store.state.openid == ''){
            let openid = this.$route.query.openId
            this.$store.dispatch('SAVEUSERACTION',openid)
        }
        this.getSalary();

        // if(this.$store.state.openid == ''){
        //     this.$cookies.set('history','person',60 * 60 * 1)
        //     let url = encodeURI('http://testwx-platform.engma.net/#/person')
        //     window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx815dbde2374f3068&response_type=code&scope=snsapi_base&redirect_uri=${url}&state=person#wechat_redirect`
        // }else{
        //     this.openid =  this.init()
        // }
        // this.getSalary();
    },
    methods: {
        async init(){
            let _this = this
            const res = await getOpenId("/wxAuth/codeToOpenid",{code:GetQueryString('code')});
            if(res.msg == 'success'){
                _this.$store.dispatch('SAVEUSERACTION',res.data)
                return res.data
            }
        },
        async getSalary(payday = this.day) {
            const res = await getPerson("/front/personalinfo/info");
            if(res.msg == '您还没有实名认证'){
                this.show = true
            }else if(res.msg == 'success'){
                this.info = res.personalInfo
            }
        },
        confirm(){
            this.$cookies.set('history','person',60 * 60 * 1)
            this.$router.push('./Certification')
        },
    },
};
</script>

<style lang="less" scoped>
.title {
    width: 100%;
    height: 100%;
    display: flex;
    font-weight: 700;
    align-items: center;
    justify-content: center;
}
.userinfo {
    width: 100%;
    align-items: center;
    li {
        list-style: none;
        margin: 40px 0;
        padding: 0px 20px;
        div {
            font-weight: 600;
            font-size: 14px;
            display: inline-block;
            min-width: 70px;
        }
        span{
            margin-left: 20px;
        }
    }
}
.cont{
    text-align: center;
    padding: 20px;
}
</style>
